import { useEffect } from 'react'
import { setContentHeaderPluginEnabled } from '@/features/contentHeaderPlugin/contentHeaderPluginSlice'
import { useAppDispatch } from '@/store/hooks'

export const useShowContentHeaderPlugin = () => {
  const dispatch = useAppDispatch()

  useEffect(() => {
    dispatch(setContentHeaderPluginEnabled(true))

    return () => {
      dispatch(setContentHeaderPluginEnabled(false))
    }
  }, [dispatch])
}
